angular.module('unergie.main')
.filter('dealStatusTitle', (DealStatuses) =>
    function (val, desc) {
        return DealStatuses[val] ? DealStatuses[val][desc ? 'description' : 'title'] : val
    }
)
